import React, { useState, useCallback } from 'react';
import { Search, X } from 'lucide-react';
import { Input } from '@/components/ui/input';
import { Button } from '@/components/ui/button';
import { useWardStore } from '@/stores/wardStore';
import { VI_MESSAGES } from '@/constants/vietnamese';
import { useVietnameseInput } from '@/hooks/useVietnameseInput';
import { debounce } from '@/utils/debounce';

export function WardSearch() {
  const { filters, updateFilters } = useWardStore();
  const [localValue, setLocalValue] = useState(filters.searchTerm);
  const { inputRef, handleInputChange } = useVietnameseInput();

  // Debounced search update
  const debouncedSearch = useCallback(
    debounce((value: string) => {
      updateFilters({ searchTerm: value });
    }, 300),
    [updateFilters]
  );

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value;
    setLocalValue(value);
    handleInputChange(e);
    debouncedSearch(value);
  };

  const handleClear = () => {
    setLocalValue('');
    updateFilters({ searchTerm: '' });
    inputRef.current?.focus();
  };

  return (
    <div className="relative">
      <Search className="absolute left-3 top-1/2 h-4 w-4 -translate-y-1/2 text-gray-400" />
      <Input
        ref={inputRef}
        type="text"
        value={localValue}
        onChange={handleChange}
        placeholder={VI_MESSAGES.WARD.SEARCH_PLACEHOLDER}
        className="pl-10 pr-10"
      />
      {localValue && (
        <Button
          variant="ghost"
          size="icon"
          onClick={handleClear}
          className="absolute right-1 top-1/2 h-7 w-7 -translate-y-1/2"
          aria-label={VI_MESSAGES.COMMON.CLEAR}
        >
          <X className="h-4 w-4" />
        </Button>
      )}
    </div>
  );
}